export class FrameTimeoutError extends Error {
  constructor(deltaMs: number, options?: ErrorOptions) {
    super(`Frame timeout: ${deltaMs}ms`, options);
  }
}

class FrameTimeout {
  private retryCount = 0;

  constructor(
    public targetMs = 1000 / 60,
    public retryLimit = 1,
    private currentFrameTime = Date.now()
  ) {
    this.trackFrameTime();
  }

  set targetFps(fps: number) {
    this.targetMs = 1000 / fps;
  }

  trackFrameTime = () => {
    const loop = () => {
      this.currentFrameTime = Date.now();
      requestAnimationFrame(loop);
    };

    requestAnimationFrame(loop);
  };

  /**
   * Throw an error if the current frame has exceeded the target frame time.
   * useful for exiting a loop early if it's taking too long.
   *
   * @param ms override timeout in milliseconds
   */
  throwOnFrameTimeout = (ms = this.targetMs) => {
    const delta = Date.now() - this.currentFrameTime;
    if (delta > ms && this.retryLimit > this.retryCount++) {
      throw new FrameTimeoutError(delta);
    } else {
      this.retryCount = 0;
    }
  };
}

/**
 * @inheritDoc FrameTimeout.throwOnFrameTimeout
 */
export const throwOnFrameTimeout = new FrameTimeout().throwOnFrameTimeout;
